import { Button } from "antd";

export const DownloadDocumentButton = ({
    showButton,
    icon,
    title,
    onDownload,
    invoice,
    setLoading,
    disabled
}) => {
    if (!showButton) {
        return null;
    }

    return (
        <Button
            icon={icon}
            size="small"
            onClick={() => onDownload(invoice, setLoading)}
            title={title}
            disabled={disabled}
        />
    );
};